<template>
  <div class="form-group">
    <label for="state">Billing State</label>

    <select :disabled="disabled" id="state" class="form-control" @change="onChange">
      <option value=""></option>
      <option v-for="state in states" :key="state.abbreviation" :value="state.abbreviation">
        {{ state.name }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'state-select',
  props: {
    disabled: {
      type: Boolean,
    },
    states: {
      type: Array,
      required: true,
    },
  },
  methods: {
    onChange(event) {
      this.$emit('input', event.target.value);
    },
  },
};
</script>

<style lang="scss" scoped></style>
